import { Component } from "react";
import { connect } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDTypography from "components/MDTypography";

import ImageUpload from "components/CustomUpload/ImageUpload";

import { SET_POST_FILES_IMAGES, REMOVE_POST_IMAGE } from "actions/types";

class Step2 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		return true;
	}

	onImageLoaded = (name, imagePreviewUrl) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_POST_FILES_IMAGES,
			payload: [{ name, base64: imagePreviewUrl }]
		});
	};

	onImageRemoved = () => {
		this.props.dispatch({
			type: REMOVE_POST_IMAGE
		});
	};

	render() {
		const { photoUri } = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12} sm={4}>
					<MDTypography component="div" variant="h6" mb={1}>
						Image
					</MDTypography>
					<ImageUpload
						onImageLoaded={this.onImageLoaded}
						onImageRemoved={this.onImageRemoved}
						photoUri={photoUri}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const { photoUri } = state.eventReducer;
	return {
		photoUri
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	Step2
);
